import { recordMark } from '@stitch-fix/client-analytics-reporter';
import { sendLog } from '../../utils/sendMetrics';
import { useGetOutfitSandboxQuery } from './getOutfitSandbox';

const useOutfitSandboxQuery = ({
  outfitId,
  skip,
}: {
  outfitId: string;
  skip: boolean;
}) => {
  const {
    data: outfitSandboxData,
    loading: outfitSandboxLoading,
    error: outfitSandboxError,
  } = useGetOutfitSandboxQuery({
    skip,
    variables: {
      outfitId,
    },
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      recordMark('get_outfit_sandbox_graph_query_completed', {
        graph_query_succeeded: true,
      });
    },
    onError: () => {
      recordMark('get_outfit_sandbox_graph_query_completed', {
        graph_query_succeeded: false,
      });

      sendLog(
        `GetOutfitSandbox error for sku ID ${outfitId}: ${outfitSandboxError}`,
        {
          outfitId,
          error_message: outfitSandboxError,
        },
      );
    },
  });

  return {
    outfitSandboxData,
    outfitSandboxLoading,
    outfitSandboxError,
  };
};

export default useOutfitSandboxQuery;
